import { useEffect, useState } from 'react';

import client from '../api/client';

// GET /api/product?category=&q=&page=&limit=&sort=
// -> { items, page, limit, total, pages }
// category accepts a category id or slug; sort ∈ newest|oldest|price_asc|price_desc|title
// `enabled: false` skips the fetch entirely (e.g. CategoryPage only needs
// this on leaf category views, not on non-leaf/root views).
export default function useProducts({ category, q, page = 1, limit = 12, sort = 'newest', enabled = true } = {}) {
  const [data, setData] = useState({ items: [], page: 1, pages: 1, total: 0, limit });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }
    let active = true;
    setLoading(true);

    const params = {};
    if (category) params.category = category;
    if (q) params.q = q;
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (sort) params.sort = sort;

    client
      .get('/product', { params })
      .then(({ data: res }) => {
        if (!active) return;
        setData({
          items: res.items || [],
          page: res.page || 1,
          pages: res.pages || 1,
          total: res.total || 0,
          limit: res.limit || limit,
        });
        setError(null);
      })
      .catch((err) => {
        if (!active) return;
        setError(err);
        setData((d) => ({ ...d, items: [] }));
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [category, q, page, limit, sort, enabled]);

  return { ...data, loading, error };
}
